<template>
  <v-app-bar absolute flat app light color="transparent" height="75">
    <v-btn class="mr-3" elevation="1" fab small @click="toggleDrawer">
      <v-icon v-if="drawer">mdi-dots-vertical</v-icon>
      <v-icon v-else>mdi-view-quilt</v-icon>
    </v-btn>

    <v-img class="hidden-lg-and-up" src="@/assets/mcc.png" max-width="50" contain></v-img>

    <v-toolbar-title class="hidden-md-and-down font-weight-light">{{ $route.name }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn class="ml-2" min-width="0" text to="/">
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>

    <v-btn class="ml-2" min-width="0" text to="/user">
      <v-icon>mdi-account</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppBar",
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    }
  },
  methods: {
    toggleDrawer: function() {
      var drawer = this.$store.state.drawer;
      this.$store.commit("SET_DRAWER", !drawer);
      console.log(this.$store.state.drawer);
    }
  }
};
</script>
